import React, { useState } from 'react';
import { useController } from './controller';
import { useParticles } from './particles';
import * as S from './styles';
import DefaultLoading from '../../components/DefaultLoading';
import { translations, LanguageKeys } from './translation';
import { Helmet } from "react-helmet"
import Particles from "@tsparticles/react";

const LandingPage = (props: any) => {
    const controller = useController();

    return (
        <S.mainContainer>
            <S.loginHeader>
                <S.logo src={`./images/Logo_and_name_transparent_bg_var.png`} alt="Logo" />
                <S.headerButtonsWrapper>
                    <S.headerButton onClick={() => controller.general.GoToRoute('/login')}>
                        {translations[controller.currentLanguage].ctaButtonLogin}
                    </S.headerButton>
                    <S.headerButton onClick={() => controller.general.GoToRoute('/register')}>
                        {translations[controller.currentLanguage].ctaButtonRegister}
                    </S.headerButton>
                </S.headerButtonsWrapper>
            </S.loginHeader>
            <S.mainInfo>
                <S.ctaArea>
                    <S.mainTitle>
                        {translations[controller.currentLanguage].mainTitle}
                    </S.mainTitle>
                    <S.subTitle>
                        {translations[controller.currentLanguage].subTitle}
                    </S.subTitle>
                    <S.startCta onClick={() => controller.general.GoToRoute('/register')}>
                        {translations[controller.currentLanguage].ctaButton}
                    </S.startCta>
                </S.ctaArea>
                <S.imageArea>
                    <S.mainImage src={`./images/showing_responsive_layout.png`} alt="Landing Page" />
                </S.imageArea>
            </S.mainInfo>
            <S.infobitsArea>
                {translations[controller.currentLanguage].advantages.map((infobit, index) => (
                    <S.infobit>
                        <S.infobitTitle>
                            {infobit.title}
                        </S.infobitTitle>
                        <S.infobitSubtitle>
                            {infobit.description}
                        </S.infobitSubtitle>
                    </S.infobit>
                ))}
            </S.infobitsArea>
            <S.persuasiveInfo>
                <S.persuasiveTextArea>
                    <S.persuasiveTitle>
                        {translations[controller.currentLanguage]['persuasiveInfoOne'].title}
                    </S.persuasiveTitle>
                    <S.persuasiveText>
                        {translations[controller.currentLanguage]['persuasiveInfoOne'].text}
                    </S.persuasiveText>
                </S.persuasiveTextArea>
                <S.persuasiveImage src={`./images/info_learnarez_1.png`} alt="Info image 1" />
            </S.persuasiveInfo>
            <S.persuasiveInfo className='reverse'>
                <S.persuasiveTextArea>
                    <S.persuasiveTitle>
                        {translations[controller.currentLanguage]['persuasiveInfoTwo'].title}
                    </S.persuasiveTitle>
                    <S.persuasiveText>
                        {translations[controller.currentLanguage]['persuasiveInfoTwo'].text}
                    </S.persuasiveText>
                </S.persuasiveTextArea>
                <S.persuasiveImage src={`./images/info_learnarez_2.png`} alt="Info image 1" />
            </S.persuasiveInfo>
            <S.pageTitle>
                {translations[controller.currentLanguage].frequentlyAskedQuestionsTitle}
            </S.pageTitle>
            <S.infobitsArea>
                {translations[controller.currentLanguage].frequentlyAskedQuestions.map((infobit, index) => (
                    <S.infobit>
                        <S.infobitTitle>
                            {infobit.question}
                        </S.infobitTitle>
                        <S.infobitSubtitle>
                            {infobit.answer}
                        </S.infobitSubtitle>
                    </S.infobit>
                ))}
            </S.infobitsArea>
            <S.lastCtaText>
                {translations[controller.currentLanguage].lastCTA}
            </S.lastCtaText>
            <S.lastCta onClick={() => controller.general.GoToRoute('/register')}>
                {translations[controller.currentLanguage].ctaButton}
            </S.lastCta>
            <S.footer>
                LearnArez © {new Date().getFullYear()} - All rights reserved.
            </S.footer>
        </S.mainContainer>
    )
}

const MountedComponent = (props: any) => {
    const particles = useParticles();

    return (
        <>
            <Particles
                id="tsparticles"
                particlesLoaded={particles.particlesLoaded as any}
                options={particles.options}
            />
            <LandingPage />
        </>
    )
}

export default MountedComponent;